import { CommonUtil } from './commonUtil';

/**
 * @Author:
 * @Description:
 * @DateTime: Created in 11:21 2020/10/9
 */


export default class RegexCheck {

	// 邮箱正则
	static emailRegex = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/

	// 基础联系电话正则
	static basicPhoneRegex = /^(0?1[0-9]{10})$|^((0(10|2[1-3]|[3-9]\d{2}))?[1-9]\d{6,7})$/
	static mobilePhoneRegex = /^1[0-9]{10}$/

	// 身份证校验
	static  perosonId= /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/

	static checkEmail(rule, value, callback):void {
		if(!value){
			return callback()
		}
		if (!RegexCheck.emailRegex.test(value)) {
			callback(new Error('邮箱格式不正确'))
		} else {
			callback()
		}
	}

	static checkBasicPhone(rule, value, callback):void {
		if(!value){
			return callback()
		}
		if (!RegexCheck.basicPhoneRegex.test(value)) {
			callback(new Error('联系电话格式不正确'))
		} else {
			callback()
		}
	}
	static checkMobilePhone(rule, value, callback):void {
		if(!value){
			return callback()
		}
		if (!RegexCheck.mobilePhoneRegex.test(value)) {
			callback(new Error('手机号格式不正确！'))
		} else {
			callback()
		}
	}

	static checkPersonId(rule, value, callback):void {
		if(!value){
			return callback()
		}
		if (!RegexCheck.perosonId.test(value)) {
			callback(new Error('身份证格式不正确'))
		} else {
			callback()
		}
	}

	/**
	 * 校验省市区联动选择器
	 */
	static checkArea(rule, value, callback) {
		if(CommonUtil.isArray(value) && value.length>0) {
			callback()
		} else {
			callback(new Error('请选择地址'))
		}
	}


}